import { render, staticRenderFns } from "./SfHeader.vue?vue&type=template&id=335aea87&"
import script from "./SfHeader.vue?vue&type=script&lang=js&"
export * from "./SfHeader.vue?vue&type=script&lang=js&"
import style0 from "./SfHeader.vue?vue&type=style&index=0&id=335aea87&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports